export default __webpack_public_path__ + "static/media/ru.05234af2.svg";